/**
 * Purchases reports listing — saved purchase reports.
 */
import { CreditCard, Calendar, Filter } from 'lucide-react';
import { ReportsPage } from '@/components/reports/ReportsPage';
import { ConfigBadge } from '@/components/reports/ConfigBadge';
import { PRESET_LABELS } from '@/lib/reports.types';
import { countFilters } from '@/lib/filters';

const iconCls = 'w-3 h-3 shrink-0';

function renderBadges(config: Record<string, unknown>) {
  const preset = ((config.datePreset as string) || (config.preset as string) || '');
  const startDate = ((config.startDate as string) || (config.start as string) || '');
  const endDate = ((config.endDate as string) || (config.end as string) || '');
  const filterCount = countFilters(config.filters);

  const dateLabel = preset
    ? PRESET_LABELS[preset] || preset.replace(/_/g, ' ')
    : startDate && endDate ? `${startDate} → ${endDate}` : '';

  return (
    <>
      {dateLabel && <ConfigBadge icon={<Calendar className={iconCls} />} text={dateLabel} color="amber" />}
      {filterCount > 0 && <ConfigBadge icon={<Filter className={iconCls} />} text={`${filterCount} filter${filterCount > 1 ? 's' : ''}`} color="rose" />}
    </>
  );
}

export function PurchasesReports() {
  return (
    <ReportsPage
      sectionId="purchases"
      sectionRoute="/purchases"
      title="Purchases"
      subtitle="Track subscriptions, revenue, and subscriber lifecycle events"
      emptyIcon={CreditCard}
      emptyDescription='Click "New Report" to create your first purchase report'
      showFolders
      accentColor="brand"
      cardIcon={<CreditCard className="w-4 h-4 text-brand-500" />}
      cardIconBgClass="bg-brand-50"
      renderBadges={renderBadges}
    />
  );
}
